import type { Middleware } from "@reduxjs/toolkit"
import { setupUWA } from "@onestore/uwa"
import { CheckoutActions } from "@gatsby-plugin-checkout/store/constants"
import log from "~/lib/log"

export const uwaMiddleware: Middleware = () => (next) => async (action) => {
  if (
    process.env.GATSBY_STORE_DOMAIN &&
    [
      CheckoutActions.USER_REGISTER_SUCCESS,
      CheckoutActions.AUTH_SUCCESS,
      CheckoutActions.USER_REGISTER_SUCCESS,
      CheckoutActions.PAYMENT_SUCCESS,
      CheckoutActions.USER_DATA_SUCCESS,
    ].includes(action.type)
  ) {
    try {
      let accountId: number | null = null

      if (action.accountId) {
        accountId = action.accountId
      }

      if (
        action.type === CheckoutActions.USER_DATA_SUCCESS &&
        action?.result?.user?.id
      ) {
        accountId = action.result.user.id
      }

      if (accountId) {
        setupUWA(process.env.GATSBY_STORE_DOMAIN, accountId).then(() => {
          log(
            `uwa setup complete for domain ${process.env.GATSBY_STORE_DOMAIN}`,
            "uwa"
          )
        })
      }
    } catch (error) {
      log(error, "uwa")
    }
  }

  return next(action)
}
